import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import { post } from 'helpers/api';

export default function CreateListingControls({ deal, onClose, onCreate }) {
  const [saving, setSaving] = useState();

  async function createListing() {
    setSaving(true);
    const listing = await post(deal.createListingPath);
    setSaving(false);
    onCreate(listing);
  }

  return <React.Fragment>
    <Button label="Cancel" variant="ghost" onClick={onClose} />
    <Button disabled={saving} label="Create Listing" onClick={createListing} />
  </React.Fragment>;
}

CreateListingControls.propTypes = {
  deal: PropTypes.shape({
    createListingPath: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};
